var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckpointEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 246,
    viewBox: "0 0 143 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1270_4342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5 238L22.5696 110.5C60.5228 137.926 81.983 137.748 120.43 110.5L71.5 238Z",
    fill: "#1100D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.375 111.855L71.5 236.604L23.6346 111.88C41.9945 124.962 56.5999 131.525 71.3155 131.503C86.0373 131.481 100.767 124.869 119.375 111.855Z",
    stroke: "#008B8B",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1270_4342)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.5,
    cy: 68,
    rx: 67.5,
    ry: 68,
    fill: "#2000E4",
    fillOpacity: 0.78,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 68C134.5 103.101 106.263 131.5 71.5 131.5C36.7373 131.5 8.5 103.101 8.5 68C8.5 32.8985 36.7373 4.5 71.5 4.5C106.263 4.5 134.5 32.8985 134.5 68Z",
    stroke: "#2000E4",
    strokeOpacity: 0.78,
    strokeWidth: 9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 68C134.5 103.101 106.263 131.5 71.5 131.5C36.7373 131.5 8.5 103.101 8.5 68C8.5 32.8985 36.7373 4.5 71.5 4.5C106.263 4.5 134.5 32.8985 134.5 68Z",
    stroke: "#492A2A",
    strokeOpacity: 0.2,
    strokeWidth: 9,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.4286 80.9862L105 40L113.214 48.5L62.4286 99L27.2233 69.5L35 59.8966L62.4286 80.9862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1270_4342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 174L72 238C68.6611 229.582 59.8745 210.739 51.4393 202.714C43.0042 194.688 19.6318 180.227 9 174Z",
    fill: "black",
    fillOpacity: 0.33
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1270_4342",
    x: 0,
    y: 0,
    width: 143,
    height: 246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1270_4342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1270_4342",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1270_4342",
    x: 0,
    y: 0,
    width: 143,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1270_4342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1270_4342",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1270_4342",
    x: 2,
    y: 167,
    width: 77,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1270_4342"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckpointEdit);
export default __webpack_public_path__ + "static/media/checkpoint-edit.30ae0914b97e4044fbaf732d9d266a11.svg";
export { ForwardRef as ReactComponent };